import { Box, Skeleton } from "@mui/material"

const UserDetails2Skeleton=()=>{

    return (
        <Box sx={{width: "100%", display:"flex"}}>

        <Box sx={{marginTop:"30px", width:"20%", marginLeft:"3%"}}>
            
            <Box sx={{ pt: 0.5 }}>
                          <Skeleton width="98%" />
                          <Skeleton width="80%" />
             </Box>
              <Skeleton variant="rectangular" width={"100%"}  height={"60vh"}  />
          
          
        </Box>

        <Box sx={{marginTop:"30px", width:"40%", marginLeft:"3%"}}>
            
          <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="98%" />
                        <Skeleton width="80%" />
           </Box>
            <Skeleton variant="rectangular" width={"100%"}  height={"50vh"}  />
        </Box>

        <Box sx={{marginTop:"30px", width:"25%", marginLeft:"3%"}}>
            
          <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="98%" />
                        <Skeleton width="80%" />
           </Box>
            <Skeleton variant="rectangular" width={"100%"}  height={"25vh"}  />
        </Box>


    </Box>
    )

}

export default UserDetails2Skeleton